function PastTournaments() {
    return (
        <div className="pastTournContainer">
            {/*HTML CODE GOES IN HERE :> -KD  */}
            <h2 className="p_TournTitle">Past Tournaments</h2>
            <div className="p_TournAlign">
                <div className="pastTourn_Name">
                    <ul className="pastTourn_ListA">
                    <p className="p_TournData1"> pastData_Name </p>
                    <p className="p_TournData2"> pastData_Name </p>
                    <p className="p_TournData1"> pastData_Name </p>
                    <p className="p_TournData2"> pastData_Name </p>
                    <p className="p_TournData1"> pastData_Name </p>

                    </ul>
                    </div>
            </div>

        </div>
    );
}

export default PastTournaments;